import { env } from "../config/env";
import type { PastorDistrictDto } from "../types/city";
import { apiRequest } from "./client";

let pastorDistrictsRequest: Promise<PastorDistrictDto[]> | null = null;

function normalizePastorDistrictsResponse(body: unknown): PastorDistrictDto[] {
  const items = Array.isArray(body)
    ? body
    : body && typeof body === "object" && "data" in body
      ? (body as { data: unknown }).data
      : [];

  if (!Array.isArray(items)) return [];

  return items.flatMap((item) => {
    if (!item || typeof item !== "object") return [];
    const district = item as Record<string, unknown>;
    const id = Number(district.id);
    const districtName =
      typeof district.districtName === "string"
        ? district.districtName.trim()
        : "";
    if (!Number.isFinite(id) || !districtName) return [];

    return [{ ...district, id, districtName } as PastorDistrictDto];
  });
}

export function fetchPastorDistricts(): Promise<PastorDistrictDto[]> {
  if (pastorDistrictsRequest) return pastorDistrictsRequest;

  pastorDistrictsRequest = apiRequest<unknown>("/api/v1/geo/pastor-districts", {
    baseUrl: env.identityApiBaseUrl,
    auth: false,
    credentials: "omit",
  })
    .then(normalizePastorDistrictsResponse)
    .catch((error) => {
      pastorDistrictsRequest = null;
      throw error;
    });

  return pastorDistrictsRequest;
}

export function clearPastorDistrictsCache(): void {
  pastorDistrictsRequest = null;
}
